import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: ${(p) => p.position && 'row-reverse'};
  justify-content: ${(p) => (p.position ? 'left' : 'right')};
  align-items: center;
`;

export const Styled = {
  Container,
};
